<template>
  <module-page v-bind="pageParams" :customBreadcrumbs="customBreadcrumbs">
    <Modal
      v-if="isScheduled === false && isWithinTheSchedulingDeadline"
      v-slot:activator
      message="Condições para realização de vistoria na unidade"
      :messageInformation="inspectionTerms"
    ></Modal>
    <Modal
      v-if="!isWithinTheSchedulingDeadline"
      v-slot:activator
      :useActions="false"
      message="O prazo para agendamento de vistoria foi encerrado"
      :messageInformation="endOfSchedulingDeadlineMessage"
    >
    </Modal>
    <v-layout row wrap>
      <v-flex xs12 md8 lg8>
        <v-form
          v-if="!loading && isWithinTheSchedulingDeadline"
          @submit.prevent="submit"
          ref="supportForm"
          lazy-validation
          class="pr-3"
        >
          <v-card class="mt-2 mb-5">
            <InspectionSuccess
              v-if="isScheduled == true"
              :inspectionInfoReceiver="inspectionInfo"
              :technicalDate="technicalDate"
              :isReschedulable="isReschedulable"
              :scheduledBy="scheduledBy"
              @reschedule="reschedule()"
            ></InspectionSuccess>
            <v-card-text v-else class="pt-1">
              <!-- retangulo do card -->

              <v-flex class="rectangle mt-3 mb-3">
                <v-card-text class="text-xs-center align-center">
                  <span class="card-rectangle__title">{{
                    $t('labels.inspectFormLocal')
                  }}</span>
                  <span class="d-block">{{ address }}</span>
                </v-card-text>
              </v-flex>

              <!-- fim retangulo do card -->

              <v-layout row wrap>
                <v-flex xs12 sm5 md6 lg8 xl3>
                  <!-- select da pagina -->
                  <template>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 md4>
                        <v-menu
                          ref="menu"
                          v-model="menu"
                          :nudge-right="40"
                          :return-value.sync="date"
                          lazy
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              :value="selectedDateFormatted"
                              label="Escolha uma data"
                              readonly
                              v-on="on"
                            />
                          </template>
                          <DatePicker
                            :changeDate="changeDate"
                            :dates="technicalDate"
                          ></DatePicker>
                        </v-menu>
                      </v-flex>
                    </v-layout>
                  </template>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <!--  label do horario -->

                <v-layout row wrap>
                  <HoursPicker
                    label="Escolha um horário"
                    :options="getHours"
                    :changeHour="changeHour"
                    :schedule="true"
                  />
                </v-layout>

                <!-- fim label do horario -->
              </v-layout>

              <!-- botao enviar -->
              <v-card-actions>
                <v-btn
                  :disabled="loadingApp || !scheduleSelected.text"
                  color="success"
                  class="support--background btn-md button-submit"
                  type="submit"
                >
                  <v-progress-circular
                    color="white"
                    indeterminate
                    v-if="loadingApp"
                  ></v-progress-circular>
                  <span v-else>{{ $t('labels.inspectFormSubmitBtn') }}</span>
                </v-btn>
              </v-card-actions>

              <!-- fim botao enviar -->
            </v-card-text>
          </v-card>
        </v-form>
        <div v-else>
          <v-card class="mt-2 mb-5">
            <v-card-text class="pt-1">
              <v-flex class="rectangle mt-3 mb-3">
                <v-card-text class="text-xs-center align-center">
                  <span class="card-rectangle__title">
                    {{ $t('labels.inspectionUnavailable') }}
                  </span>
                </v-card-text>
              </v-flex>
            </v-card-text>
          </v-card>
        </div>
        <div>
          <ScreenLoading v-if="loading" />
        </div>
      </v-flex>

      <!-- Codigo abaixo resposavel pelo campo perguntas frequentes-->
      <v-flex xs12 md4 lg4 class="mt-4 mb-4">
        <faq-card
          :items="faqItems"
          :loading="faqLoading"
          :error="faqError"
          :params="faqCardParams"
          :errorText="$t('responses.error')"
          @faqSelected="goToFaq"
          :retryFunction="getFaqs"
        ></faq-card>
      </v-flex>
    </v-layout>
  </module-page>
</template>

<script>
import bus from '@/utils/bus';
import enums from '@/utils/enums';
import { APP, CONFIG, EVENTS } from '@/utils/constants';
import { contractIsActive, getUnitProposersInfo } from '@/utils';
import faqMixin from '@/mixins/modules/faq';
import supportMixin from '@/mixins/modules/support';
import profile from '@/mixins/modules/profile';

import ModulePage from '@/components/layout/Page';
import FaqCard from '@/components/modules/FaqCard';
import SelectField from '@/components/fields/Select';
import ScreenLoading from '@/components/loaders/ScreenLoading';
import getCurrentBandwidth from '@/utils/bandwidth';

import Schedules from '@/components/fields/HoursPicker';
import addressService from '@/services/address';
import Modal from '@/components/shared/Modal';
import InspectionSuccess from '@/components/support/InspectionSuccess';
import HoursPicker from '@/components/fields/HoursPicker';
import DatePicker from '@/components/fields/DatePicker';
import eventsMixin from '@/mixins/modules/events';
import moment from 'moment';
export default {
  name: 'inspectionDetails',
  mixins: [faqMixin, supportMixin, eventsMixin],
  components: {
    ModulePage,
    FaqCard,
    SelectField,
    ScreenLoading,
    Modal,
    Schedules,
    InspectionSuccess,
    DatePicker,
    HoursPicker,
  },
  computed: {
    inspection() {
      return this.$store.getters[EVENTS.GET_INSPECTION];
    },
    inspectionTerms() {
      return (this.$store.getters[CONFIG.GET] || { texts: {} }).texts
        .inspectionTerms;
    },
    endOfSchedulingDeadlineMessage() {
      return (this.$store.getters[CONFIG.GET] || { texts: {} }).texts
        .endOfInspectionSchedulingPeriodMessage;
    },
    getHours() {
      return this.technicalDate.filter(
        (item) => item.date === this.selectedDate
      );
    },
    customBreadcrumbs() {
      const path = this.$route.path;
      const tab = this.pageParams.tabs.find((tab) => tab.value == path);
      if (tab) {
        const title = tab.title.mobile
          ? this.mobile
            ? tab.title.mobile
            : tab.title.notMobile
          : tab.title;
        return [{ text: title }];
      } else {
        return [{ text: this.$t('labels.inspectionFormTitleBreadcrumbs') }];
      }
    },
    isWithinTheSchedulingDeadline() {
      const now = moment();
      if (this.exhibitionEndDate && this.exhibitionEndDate.isBefore(now)) {
        return false;
      }
      return true;
    },
  },
  data() {
    return {
      pageParams: this.$store.getters[APP.PAGES].inspectionDetails,
      faqCardParams: this.$store.getters[APP.APP_MODULES].faq,
      scheduleValue: '',
      schedule: '',
      scheduledBy: '',
      productTitle: '',
      productBlock: '',
      productUnit: '',
      productAddress: '',
      isScheduled: true,
      inspectionInfo: {},
      date: new Date().toISOString().substr(0, 10),
      menu: false,

      //schedule
      selectedDateFormatted: this.formatDate(new Date()),
      address: '',
      timesArray: [],
      technicalSchedule: [],
      technicalDate: [],
      selectedDate: new Date().toISOString().substr(0, 10),
      scheduleSelected: {},
      isReschedulable: true,
      loading: false,
      firstPeriod: '',
      exhibitionEndDate: null,
    };
  },
  //busca informações do select via banco AWS
  async created() {
    bus.$on('unit:change', this.reloadInspection);
    bus.$on('unit:update', this.reloadInspection);
    this.getFaqs();
    this.loadInspection();
    this.loading = true;
  },
  beforeDestroy() {
    bus.$off('unit:change', this.reloadInspection);
    bus.$off('unit:update', this.reloadInspection);
  },
  methods: {
    receiveSchedule(schedule) {
      this.scheduleValue = schedule;
    },

    reloadInspection() {
      this.loadInspection(true);
    },

    async loadInspection(reloading) {
      this.loading = true;
      if (reloading || !this.inspection) {
        await this.getEvent(['inspection'], { onlyCount: false });
      }
      if (this.inspection) {
        this.address = this.inspection.address;
        this.firstPeriod = this.inspection.periods.sort((a, b) =>
          moment(a.date).diff(moment(b.date))
        )[0];
        this.exhibitionEndDate = this.inspection.exhibitionEndDate
          ? moment(this.inspection.exhibitionEndDate)
          : moment(firstPeriod.date).add(-7, 'days');
        this.selectedDate = this.inspection.date.substr(0, 10);
        this.selectedDateFormatted = this.formatDate(this.inspection.date);
      } else {
        this.$router.push({ name: 'home' });
      }
      await Promise.all([this.getDates(), this.canReschedule()]);
      this.loading = false;
    },

    async getInspectEvent() {
      const inspection = this.inspection;
      if (inspection && inspection._id) {
        this.inspectionEventId = inspection._id;
        const params = {
          username: this.user.username,
        };
        const url = `${process.env.EVENT_API_URL}/${this.inspectionEventId}`;
        const result = await this.requestService(url, 'GET', {
          params,
        });

        this.address = result.address;
      }
    },

    async canReschedule() {
      const inspection = this.inspection;
      if (inspection && inspection._id) {
        this.inspectionEventId = inspection._id;
        const usernames = getUnitProposersInfo(this.selectedUnit, 'document');
        const params = {
          usernames,
          sku: this.selectedUnit.sku,
          desiredFields: {
            _id: 1,
            eventId: 1,
            date: 1,
            address: 1,
            targetEventType: 1,
            Evento: 1,
            'user.username': 1,
            'user.fullName': 1,
          },
        };
        const url = `${process.env.SCHEDULE_API_URL}/event/${this.inspectionEventId}`;

        let result = await this.requestService(url, 'GET', { params });
        const isValid = result && !!result.length;
        if (isValid) {
          const eventDate = this.toDefaultTimezone(
            result[result.length - 1].date
          );
          const [date, scheduleValue] = eventDate
            .format('YYYY-MM-DDTHH:mm')
            .split('T');
          this.inspectionInfo = {
            id: result[result.length - 1]._id,
            eventDate: eventDate.format(),
            date,
            scheduleValue,
            productTitle: this.selectedUnit.product.title,
            productBlock: this.selectedUnit.block.title,
            productUnit: this.selectedUnit.unit.code,
            productAddress: this.address,
          };
          const isAuthor = result[0].user.username === usernames[0];
          this.scheduledBy = !isAuthor ? result[0].user.fullName : '';
          this.isReschedulable =
            isAuthor && eventDate.subtract(7, 'days').isSameOrAfter();
        }
        this.isScheduled = isValid;
      }
    },

    async getDates() {
      const inspection = this.inspection;
      if (inspection && inspection._id) {
        this.inspectionEventId = inspection._id;
        let dates = [];
        if (inspection.periods) {
          dates = [
            ...new Set(
              inspection.periods.map((period) => period.date.split('T')[0])
            ),
          ];
        } else {
          const params = {
            username: this.user.username,
          };

          const urlEvent = `${process.env.EVENT_API_URL}/${this.inspectionEventId}`;
          const eventPeriods = await this.requestService(urlEvent, 'GET', {
            params,
          });
          dates = [
            ...new Set(
              eventPeriods.periods.map((period) => period.date.split('T')[0])
            ),
          ];
        }

        // dates.forEach(async element => {
        //   await this.callTimesAvailables(element);
        // });

        this.callTimesAvailables(dates);
      }
    },
    async callTimesAvailables(localDates) {
      let arrayPeriod = [];
      const data = {
        username: this.user.username,
        dates: localDates,
      };
      const url = `${process.env.EVENT_API_URL}/${this.inspectionEventId}/schedule`;
      const result = await this.requestService(url, 'POST', {
        data,
      });
      if (result) {
        arrayPeriod = result.map((item) => {
          let [localDate, localHour] = this.formatTimezone(item.date).split(
            'T'
          );
          return {
            value: item.periodId,
            date: localDate,
            hour: localHour,
            available: item.available,
          };
        });
        this.technicalDate = [
          ...new Set(this.technicalDate.concat(arrayPeriod)),
        ];
      }
    },
    changeDate(val) {
      this.selectedDateFormatted = this.formatDate(val);
      this.selectedDate = val;
    },
    changeHour(val) {
      this.scheduleSelected = val;
    },
    async submit() {
      if (!this.scheduleSelected.text) {
        bus.$emit('snackbar:open', {
          text: 'Preencha todos os campos obrigatórios.',
          color: enums.snackbarColors.error,
        });
      } else {
        const contractId =
          this.selectedUnit.contracts.find(contractIsActive).id;
        const body = {
          username: this.user.username,
          date: this.toDefaultTimezone(
            `${this.selectedDate}T${this.scheduleSelected.text}`
          ).toISOString(),
          periodId: this.scheduleSelected.value,
          eventId: this.inspection._id,
          contractId,
        };
        const previousScheduleId = this.inspectionInfo.id;
        if (previousScheduleId) {
          body._id = previousScheduleId;
        }
        this.inspectionInfo = {
          eventDate: body.date,
          date: this.selectedDateFormatted,
          scheduleValue: this.scheduleSelected.text,
          periodId: this.scheduleSelected,
          productTitle: this.selectedUnit.product.title,
          productBlock: this.selectedUnit.block.title,
          productUnit: this.selectedUnit.unit.code,
          productAddress: this.address,
        };
        const { message, data } = await this.requestService(
          process.env.SCHEDULE_API_URL,
          'POST',
          {
            data: body,
          }
        );
        if (message) {
          this.inspectionInfo.id = data;

          const action =
            enums.logTraceActions[
              `inspection${previousScheduleId ? 'Reschedule' : 'Schedule'}`
            ];
          const details = {
            date: body.date,
            ...(!previousScheduleId
              ? {
                  termsAgreed: true,
                }
              : {}),
          };

          //SMS
          const shippingMode = this.previousScheduleId
            ? 'ReScheduled'
            : 'Scheduled';
          const smsUrl = `${process.env.SMS_API}/addToQueue`;
          const smsType = `inspection${shippingMode}`;
          const smsData = {
            contractId,
            productId: this.selectedUnit.product.id,
            blockCode: this.selectedUnit.block.code,
            unitCode: this.selectedUnit.unit.code,
            smsType,
            scheduleId: this.inspectionInfo.id,
          };
          this.requestService(smsUrl, 'POST', {
            data: smsData,
          });

          this.createTrace(action, details);
          this.createTicket(body);
          this.technicalDate = [];
          this.getDates();
          this.selectedDate = this.inspection.date.substr(0, 10);
          this.selectedDateFormatted = this.formatDate(this.inspection.date);
          this.isScheduled = true;
        }
      }
    },
    reschedule() {
      this.isScheduled = false;
    },
    async createTicket(inspection) {
      try {
        const content = this.getTicketContent(inspection);
        const payload = {
          summary: `Agendamento de vistoria de obra`,
          comments: {
            public: { content },
          },
        };
        await this.sendTicket(payload);
      } catch (error) {
        bus.$emit('snackbar:open', {
          text: this.$t('responses.error'),
          color: enums.snackbarColors.error,
        });
      }
    },
    getTicketContent(inspection) {
      const terms = this.inspectionTerms;
      const date = this.formatLongDateTime(inspection.date);
      const address = this.address;
      return `Data da vistoria de obra:\n${date}\nEndereço:\n${address}\n.\n. \n${terms}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.rectangle {
  height: auto;
  width: 100%;
  border-radius: 2px;
  background-color: #f5f5f5;
  overflow: hidden;
}

.card-rectangle__title {
  height: 19px;
  width: 141px;
  color: #0093f0;
  font-family: 'Open Sans';
  font-size: 14px;
  font-weight: 600;
  line-height: 19px;
  text-align: center;
}

.card-rectangle__border {
  border: 1px solid #cccccc !important;
  border-radius: 4px !important;
}

.card-rectangle__null {
  width: 100%;
  height: 50px;
  border-radius: 2px;
  color: #666666;
  font-family: 'Open Sans';
  font-size: 14px;
  line-height: 19px;
  text-align: center;
}

>>> .button-submit {
  margin-top: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/support/inspection/InspectionDetails.vue